import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight, Mail, CheckCircle } from "lucide-react";
import { supabase } from "../../lib/supabaseClient";

export default function Login() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    setErr("");
    const { error } = await supabase.auth.signInWithOtp({
      email: email.trim().toLowerCase(),
      options: { emailRedirectTo: window.location.origin + "/espace-client" },
    });
    setLoading(false);
    if (error) setErr(error.message);
    else setSent(true);
  };

  return (
    <div className="max-w-md mx-auto">
      <div className="text-center mb-8">
        <span className="font-mono text-xs uppercase tracking-[0.25em] text-zinc-500">
          Espace client
        </span>
        <h1 className="font-display uppercase text-4xl sm:text-5xl tracking-tighter leading-[0.9] mt-4">
          Accédez à <span className="text-outline">votre projet</span>
        </h1>
      </div>

      {sent ? (
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          className="bento p-8 text-center"
          data-testid="login-sent"
        >
          <div className="w-14 h-14 rounded-full bg-[var(--accent)] text-black flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="w-7 h-7" />
          </div>
          <h2 className="font-display text-2xl tracking-tight mb-3">Vérifiez vos emails</h2>
          <p className="text-zinc-400 text-sm leading-relaxed">
            On vient d'envoyer un lien de connexion à <span className="text-white">{email}</span>.
            Cliquez dessus pour accéder à votre espace — aucun mot de passe à retenir.
          </p>
        </motion.div>
      ) : (
        <form onSubmit={submit} className="bento p-8 space-y-5" data-testid="login-form">
          <div>
            <label className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">
              Votre email
            </label>
            <input
              type="email"
              className="field"
              placeholder="vous@commerce.fr"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="login-email"
            />
          </div>
          {err && <p className="text-sm text-red-400">{err}</p>}
          <button
            type="submit"
            disabled={loading}
            className="btn-pill btn-pill-accent w-full justify-center disabled:opacity-60"
            data-testid="login-submit"
          >
            {loading ? "Envoi…" : "Recevoir mon lien de connexion"}
            <ArrowUpRight className="w-4 h-4" />
          </button>
          <p className="flex items-center justify-center gap-2 text-[11px] text-zinc-500">
            <Mail className="w-3.5 h-3.5" /> Connexion sécurisée par lien magique
          </p>
        </form>
      )}
    </div>
  );
}
